import axios from 'axios'

export function useBpmRewrite ({
  policy,
  notify,
  sharedApi,
  loaded,
}) {
  function processRewritePolicyData (contract) {
    loaded.value = true

    const insurer = contract?.insurer ?? null
    const insureds = Array.isArray(contract?.insureds) ? contract.insureds : []
    const vehicles = Array.isArray(contract?.vehicle) ? contract.vehicle : []

    if (insurer?.client?.iin || insurer?.client?.phone || insurer?.licence?.number) {
      const client = insurer.client
      const filter = insurer.filter ?? {}
      const search = {
        phone: client.phone ?? null,
        iin: client.iin ?? null,
        nomer_vu: insurer.licence?.number ?? null,
        isPdl: false,
        isSocial: false,
      }
      const meta = {
        title: client.title ?? null,
        search,
        filter: {
          resident: filter.resident ?? true,
          person: filter.person ?? true,
          verify: filter.verify ?? true,
        },
        clientType: 1,
        processId: null,
      }
      sharedApi.addProcess(1, search, meta, 1)
    }

    insureds.forEach((insured) => {
      if (!insured?.client?.iin && !insured?.client?.phone && !insured?.licence?.number) {
        return
      }
      const client = insured.client
      const filter = insured.filter ?? {}
      const search = {
        phone: client.phone ?? null,
        iin: client.iin ?? null,
        nomer_vu: insured.licence?.number ?? null,
        isPdl: false,
        isSocial: false,
      }
      const meta = {
        title: client.title ?? null,
        search,
        filter: {
          resident: filter.resident ?? true,
          person: filter.person ?? true,
          verify: filter.verify ?? true,
        },
        clientType: 2,
        processId: null,
      }
      sharedApi.addProcess(2, search, meta, 0)
    })

    vehicles.forEach((vehicle) => {
      const registration = vehicle?.registration ?? {}
      const vin = String(vehicle?.vin ?? '').trim()
      const number = String(vehicle?.number ?? registration?.number ?? '').trim()
      const certificate = registration?.certificate ? String(registration.certificate).trim() : null
      if (!vin && !number && !certificate) {
        return
      }
      const search = {
        number: number || null,
        vin: vin || null,
        certificate: certificate || null,
      }
      const meta = {
        title: [vehicle?.color, vehicle?.mark, vehicle?.model, vehicle?.year].filter(Boolean).join(' ').trim() || null,
        search,
        filter: { type: 1, verify: true },
        processId: null,
      }
      sharedApi.addProcess(3, search, meta, 0)
    })

    sharedApi.syncAddedLists()
    loaded.value = false
  }

  function loadRewritePolicy (ulid) {
    loaded.value = true
    axios.get('api/v2/functional/contract/rewrite/draft/' + ulid)
      .then(res => {
        if (!res.data?.result) {
          notify.error(res.data)
          return
        }
        const draft = res.data.data ?? {}
        const contract = draft.contract ?? draft
        const linked = Array.isArray(draft.linked) ? draft.linked : []

        policy.rewrite.contract = structuredClone(contract)
        policy.rewrite.linked = structuredClone(linked)
        processRewritePolicyData(contract)
      })
      .catch(err => {
        notify.error(err)
      })
      .finally(() => {
        initializeAfterRewritePolicy()
      })
  }

  function initializeAfterRewritePolicy () {
    loaded.value = false
    sharedApi.applyModeTreatySettings()
    sharedApi.getManagers()
  }

  return {
    loadRewritePolicy,
    processRewritePolicyData,
    initializeAfterRewritePolicy,
  }
}
